import React, {
  createContext,
  useState,
  useEffect,
} from "react";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {

  /* PRODUCTS */

  

  const completeSale = () => {
    

  const updatedProducts = products.map(
    (product) => {

      const cartItem = cart.find(
        (item) => item.id === product.id
      );

      if (!cartItem) return product;

      const remaining =
        product.units - cartItem.qty;

      let stock = "IN STOCK";
      let statusClass = "in-stock";

      if (remaining <= 10) {
        stock = "LOW STOCK";
        statusClass = "low-stock";
      }

      if (remaining <= 0) {
        stock = "OUT OF STOCK";
        statusClass = "out-stock";
      }

      return {
        ...product,
        units:
          remaining < 0 ? 0 : remaining,

        stock,
        statusClass,
      };
    }
  );

  setProducts(updatedProducts);

  const addProduct = (product) => {

  setProducts((prev) => [

    ...prev,

    {
      ...product,
      id: Date.now(),
    },

  ]);

};

  setCart([]);
};

const totalAmount = () => {

  const subtotal = cart.reduce(
    (acc, item) => {

      const price = Number(
        item.price.replace("₹", "")
      );

      return acc + price * item.qty;

    },
    0
  );

  const totalAmount = () => {

  const subtotal = cart.reduce(

    (acc, item) => {

      const price = Number(
        item.price.replace("₹", "")
      );

      return acc + price * item.qty;

    },

    0

  );

  const totalGST = cart.reduce(

    (acc, item) => {

      const price = Number(
        item.price.replace("₹", "")
      );

      const itemSubtotal =
        price * item.qty;

      const gst =
        itemSubtotal *
        (
          Number(
            item.gstRate || 0
          ) / 100
        );

      return acc + gst;

    },

    0

  );

  return subtotal + totalGST;

};
};

const saveSale = (customer) => {

  const newSale = {

    id: Date.now(),

    invoiceNo:
      "INV-" +
      Math.floor(
        100000 + Math.random() * 900000
      ),

    date: new Date().toLocaleString(),

    customer,

    items: cart,

    paymentMethod:
  customer.paymentMethod,

    total: totalAmount(),

  };

  setSalesHistory((prev) => [
    newSale,
    ...prev,
  ]);

};
  const [products, setProducts] =
  useState(() => {

    const savedProducts =
      localStorage.getItem("products");

    return savedProducts
      ? JSON.parse(savedProducts)
      : [];

  });

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      try {
        localStorage.setItem(
          "products",
          JSON.stringify(products)
        );
      } catch (error) {
        console.error("Failed to save products:", error);
      }
    }, 250);

    return () => window.clearTimeout(timeoutId);

  }, [products]);

  const addProduct = (product) => {

    setProducts((prev) => [
      ...prev,
      {
        ...product,
        id: Date.now(),
      },
    ]);

  };

  

  /* CART */

  const [cart, setCart] = useState([]);
  const [salesHistory,
setSalesHistory] =
useState(() => {

  const savedSales =
    localStorage.getItem(
      "salesHistory"
    );

  return savedSales
    ? JSON.parse(savedSales)
    : [];

});

useEffect(() => {

  localStorage.setItem(
    "salesHistory",
    JSON.stringify(
      salesHistory
    )
  );

}, [salesHistory]);
  const [editingProduct, setEditingProduct] =
  useState(null);

  const updateProduct = (updatedProduct) => {

  setProducts((prev) =>
    prev.map((item) =>
      item.id === updatedProduct.id
        ? updatedProduct
        : item
    )
  );

};

  const addToCart = (product) => {

  if (product.units <= 0) {
    alert("Product is out of stock!");
    return;
  }

  const existing = cart.find(
    (item) => item.id === product.id
  );

  if (existing) {

    if (existing.qty >= product.units) {
      alert(`Only ${product.units} units available`);
      return;
    }

    setCart(
      cart.map((item) =>
        item.id === product.id
          ? {
              ...item,
              qty: item.qty + 1,
            }
          : item
      )
    );

  } else {

    setCart([
      ...cart,
      {
        ...product,
        qty: 1,
        gstRate: Number(product.gstRate || 0),
      },
    ]);

  }

};

  const increaseQty = (id) => {

  const cartItem = cart.find(
    (item) => item.id === id
  );

  const product = products.find(
    (p) => p.id === id
  );

  if (
    product &&
    cartItem.qty >= product.units
  ) {
    alert(`Only ${product.units} units available`);
    return;
  }

  setCart(
    cart.map((item) =>
      item.id === id
        ? {
            ...item,
            qty: item.qty + 1,
          }
        : item
    )
  );

};

  const decreaseQty = (id) => {

    const updated = cart
      .map((item) =>
        item.id === id
          ? {
              ...item,
              qty: item.qty - 1,
            }
          : item
      )
      .filter((item) => item.qty > 0);

    setCart(updated);

  };
const deleteProduct = (id) => {

  setProducts((prev) =>
    prev.filter(
      (item) => item.id !== id
    )
  );

};
  

  return (
    <ProductContext.Provider
      value={{
        products,
        addProduct,
        setProducts,
        setCart,

        cart,
        addToCart,
        increaseQty,
        decreaseQty,
        completeSale,
        saveSale,
        salesHistory,
        editingProduct,
        setEditingProduct,
        updateProduct,
        deleteProduct,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
